import styled from '@emotion/styled'

export const CookieBannerStyles = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #282b2e;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 14px;
  font-size: 0.9rem;

  a {
    color: white;
  }

  & > * {
    margin: 0 5px;
  }

  p {
    line-height: 20px;
  }
`
